import React from 'react';

function ContactSection() {
  return (
    <section className="section" id="contact" style={{ padding: '100px 0', flex: 1 }}>
      <div className="section-title">
        <h2 style={{ color: '#fff' }}>Contact</h2>
        <div className="title-bar"></div>
        <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
          
        </p>
      </div>
      <div className="container">
        <div className="about-content" style={{ background: 'rgba(255,255,255,0.9)', padding: '40px', borderRadius: 8 }}>
          <div className="about-text">
            <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.4, marginBottom: 25 }}>
              <p style={{ marginBottom: 10 }}>
                <i className="fas fa-map-marker-alt" style={{ color: 'var(--primary)', marginRight: 12 }}></i>
                6 Rue du Parc 74100 Annemasse
              </p>
              <p style={{ marginBottom: 10 }}>
                <i className="fas fa-envelope" style={{ color: 'var(--primary)', marginRight: 12 }}></i>
                info@dla-structure.fr
              </p>
            </div>
            <p style={{ marginTop: 20, fontSize: 15, color: 'var(--text-light)' }}>
              Notre équipe est à votre écoute pour répondre à toutes vos demandes.
              Que ce soit pour une étude de faisabilité, un calcul de structure ou
              un accompagnement complet, nous vous apportons des solutions sur mesure.
            </p>
          </div>
          {/*
          <div className="about-image">
            <div style={{
              background: 'var(--primary)',
              padding: '40px',
              borderRadius: '8px',
              textAlign: 'center',
              color: 'var(--dark)'
            }}>
              <h3 style={{ marginBottom: '15px' }}>Demande de devis</h3>
              <p>Contactez-nous pour obtenir un devis gratuit et personnalisé.</p>*/}
              {/*<a href="mailto:info@dla-structure.fr" className="hero-btn" style={{ marginTop: '20px', display: 'inline-block' }}>
                Envoyer un message
              </a>
            </div>
          </div>
          */}
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
